import { Component, Input } from '@angular/core';

@Component({
  selector: 'dynfilter-date',
  template: require('./dynamic-filters.date.component.html')
})
export class DynamicFilterDateComponent {
  @Input() filter: any;
  private value;
  private alias;

  ngOnInit() {
    this.value = this.filter.value;
    this.alias = this.filter.alias;
  };

  ngOnChanges() {
    this.value = this.filter.value;
    this.alias = this.filter.alias;
  };

  onUpdate($event: any) {
    this.filter.value = $event;
  }
}
